// The words on screen come from the phone app's own file
// (packages/paidlark_core/lib/l10n/arb/app_en.arb), so both apps say the same
// thing and are translated once. Messages are ICU, as in the ARB file.
import { IntlMessageFormat } from 'intl-messageformat';
import arbText from '@arb/app_en.arb?raw';

const arb = JSON.parse(arbText) as Record<string, unknown>;
const locale = typeof arb['@@locale'] === 'string' ? arb['@@locale'] : 'en';
const compiled = new Map<string, IntlMessageFormat>();

export type Values = Record<string, string | number>;

/** The words for [key], with [values] filled in. */
export function t(key: string, values?: Values): string {
  const message = arb[key];
  if (typeof message !== 'string' || key.startsWith('@')) {
    if (import.meta.env.DEV) console.warn(`No words for "${key}" in app_en.arb`);
    return key;
  }
  if (!values && !message.includes('{')) return message;
  let format = compiled.get(key);
  if (!format) {
    format = new IntlMessageFormat(message, locale, undefined, { ignoreTag: true });
    compiled.set(key, format);
  }
  return String(format.format(values));
}

/** Whether the ARB file has [key]; for tests. */
export const hasKey = (key: string) => typeof arb[key] === 'string' && !key.startsWith('@');
